module.exports = __webpack_public_path__ + "img/aej1n-66wvl.006.475e53f8.png";